module.exports = __webpack_public_path__ + "static/media/header-o-marce.c982c8dd.svg";